import React, { useState, useRef, useEffect } from 'react';
import { db,functions } from '../firebase';
import { collection, addDoc, Timestamp ,getDocs,doc,getDoc} from 'firebase/firestore';
import BackHomeButton from '../components/BackHomeButton';
import Get_Help from '../components/Get_Help';
import Help_Video from '../components/Help_Video';
import { getAuth } from 'firebase/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';


const VoicetoText = () => {
  const isIOS = () =>
    typeof window !== 'undefined' &&
    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
    !window.MSStream;

  const [lessonInputMode, setLessonInputMode] = useState('');
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [loading, setLoading] = useState(false);




  const [text, setText] = useState('');
  const [isListening, setIsListening] = useState(false);
  const [selectedLang, setSelectedLang] = useState('');
  const [availableVoices, setAvailableVoices] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState(['save','share']);
  const [subject, setSubject] = useState('');
  const [lessonName, setLessonName] = useState('');
  const textAreaRef = useRef(null);

  const [savedLessons, setSavedLessons] = useState([]);
  const [selectedLessonId, setSelectedLessonId] = useState('');

  const [showFlash, setShowFlash] = useState(false);
const [flashCountdown, setFlashCountdown] = useState(10);

const [spellingPaused, setSpellingPaused] = useState(false);
const [spellingInProgress, setSpellingInProgress] = useState(false);

const spellingPausedRef = useRef(false);

const location = useLocation();
const navigate = useNavigate();

const handleFilesChange = (e) => {
  const selectedFiles = Array.from(e.target.files);
  const validFiles = selectedFiles.filter((f) => f.size <= 6 * 1024 * 1024);

  if (validFiles.length < selectedFiles.length) {
    alert('❌ Please upload files below 6MB only');
  }

  setFiles((prevFiles) => [...prevFiles, ...validFiles]);
  setPreviews((prevPreviews) => [
    ...prevPreviews,
    ...validFiles.map((f) => URL.createObjectURL(f)),
  ]);
};

const handleRemoveImage = (index) => {
  setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
};

const handleClearAll = () => {
  setFiles([]);
  setPreviews([]);
};

  // ✅ Helper: Convert file to base64
  function getBase64(fileObj) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result;
      const parts = result.split(",");
      resolve(parts.length > 1 ? parts[1] : result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(fileObj);
  });
}

  const extractTextFromImages = async () => {
  let combinedText = '';

  setLoading(true);

  const prompt = "Extract all visible text from these images as plain text only.";

  const callGemini = httpsCallable(functions, 'callGemini');

  for (let file of files) {

    const base64 = await getBase64(file);

    //alert(base64);

      // ✅ Prepare Gemini payload
      const payload = {
        contents: [
          {
            role: "user",
            parts: [
              { text: prompt },
              {
inlineData: {
  mimeType: file.type || "image/jpeg",
  data: base64,
}
              },
            ],
          },
        ],
      };

      // ✅ Call your backend Cloud Function (replace with your deployed URL)
const result = await callGemini(payload);
const data = result.data;
      // ✅ Extract text from Gemini response
    const text =
       data?.candidates?.[0]?.content?.parts?.[0]?.text || "No text found.";

       //alert(text);

      combinedText += text + "\n";
  }

  setText((prev) => prev + '\n' + combinedText);

  setLoading(false);

  // autofocus textarea after AI fills it
  setTimeout(() => {
    textAreaRef.current?.focus();
  }, 0);
};

useEffect(() => {
  return () => previews.forEach((url) => URL.revokeObjectURL(url));
}, [previews]);


useEffect(() => {
  const state = location.state;
  if (state) {
    if (state.selectedLessonId) setSelectedLessonId(state.selectedLessonId);
    if (state.subject) setSubject(state.subject);
  }
}, [location.state]);


  const [standard, setStandard] = useState('');
  const [school, setSchool] = useState('');


  useEffect(() => {
  const fetchSavedLessons = async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) return;

    const coreSubjects = ['English Language', 'Hindi Language', 'GK', 'Maths'];

    const snapshot = await getDocs(collection(db, 'Saved_lessons'));

    const lessons = snapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(item =>
        (item.email === user.email || item.sharedWith === 'parents') 
      );
    setSavedLessons(lessons);
  };

  fetchSavedLessons();
}, []);

useEffect(() => {
  const fetchProfileData = async () => {
    const user = getAuth().currentUser;
    if (!user) return;

    try {
      const profileRef = doc(db, 'profiles', user.uid);
      const profileSnap = await getDoc(profileRef);
      if (profileSnap.exists()) {
        const profile = profileSnap.data();
        setStandard(profile.standard || '');
        setSchool(profile.school || '');
      }
    } catch (err) {
      console.error('Failed to fetch profile data:', err);
    }
  };

  fetchProfileData();
}, []);



  const resetText = () => setText('');


  const handleCheckboxChange = (e) => {
    const value = e.target.value;
    setSelectedOptions(prev =>
      prev.includes(value) ? prev.filter(opt => opt !== value) : [...prev, value]
    );
  };

const handleSubmitChoices = async () => {
  const auth = getAuth();
  const user = auth.currentUser;
  const trimmedText = text.trim();
  const isAssociated = selectedOptions.includes('associate');
  const trimmedSubject = subject.trim();
  const trimmedLessonName = lessonName.trim();

  if (!user) {
    alert('⚠️ Please log in to save.');
    return;
  }

  if (!trimmedText) {
    alert('⚠️ Text area cannot be blank.');
    return;
  }

  if (selectedOptions.length === 0) {
    alert('Please choose at least one option before submitting.');
    return;
  }

  if (isAssociated && (!trimmedSubject || !trimmedLessonName)) {
    alert('⚠️ Please fill in both Subject and Lesson Name.');
    return;
  }

  const data = {
    text: trimmedText,
    lang: selectedLang,
    timestamp: Timestamp.now(),
    optionsSelected: selectedOptions,
    uid: user.uid,
    email: user.email,
    ...(isAssociated && {
      subject: trimmedSubject,
      lessonName: trimmedLessonName,
      standard,
      school
    }),
    sharedWith: selectedOptions.includes('share') ? 'parents' : null,
    reviewStatus: 'pending',
    reviewRequestedAt: Timestamp.now(),
  };

  setLoading(true);

  try {
  const savedLessonDocRef = await addDoc(collection(db, 'Saved_Lessons_Review'), data);
  let masterDocId = '';

  // Prepare the eventual publish key, but do not write to master before review approval.
  if (isAssociated) {
    const standardNumber = Number(standard); // ensure number format
    const safeSubject = trimmedSubject.replace(/\//g, '-');
    const safeLessonName = trimmedLessonName.replace(/\//g, '-');
    masterDocId = `${standardNumber}_${safeSubject}_${safeLessonName}`;

  }

  navigate('/SubmissionThankYou', {
    replace: true,
    state: {
      submissionType: 'lesson',
      submissionDetails: {
        reviewLessonId: savedLessonDocRef.id,
        reviewCollection: 'Saved_Lessons_Review',
        masterDocId,
        ...(trimmedSubject && { subject: trimmedSubject }),
        ...(trimmedLessonName && { lessonName: trimmedLessonName }),
        language: selectedLang,
        optionsSelected: selectedOptions
      },
      returnState: { selectedLessonId, subject: trimmedSubject || subject }
    }
  });
  } catch (error) {
    console.error('Lesson submission failed:', error);
    alert('Could not submit the lesson. Please try again.');
    setLoading(false);
  }
};

{showFlash && (
  <div style={{
    position: 'fixed', top: 0, left: 0,
    width: '100%', height: '100%',
    background: '#000', color: '#fff',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '4rem', zIndex: 9999
  }}>
    {flashCountdown}
  </div>
)}

  return (
    
    <div style={styles.card}>


{showFlash && (
  <div style={{
    position: 'fixed',
    top: 0, left: 0,
    width: '100vw', height: '100vh',
    background: 'rgba(190, 187, 187, 0.6)',
    zIndex: 9998, // Make sure it's behind the pause button
    pointerEvents: 'none', // Let clicks pass through
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '5rem', color: '#fff'
  }}>
    <div>{flashCountdown}</div>
  </div>
)}


<div className="grid grid-cols-3 lg:grid-cols-3 gap-4 mb-6">

    <BackHomeButton
          backState={{
            selectedLessonId,
            subject
          }}
        />
        
        <div className="flex-auto text-center px-1 sm:px-4 shrink-0">
          <h2 className="text-lg sm:text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight leading-tight whitespace-wrap">
            Add a <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-violet-600">Lesson</span>
          </h2>
        </div>

        <Get_Help/>
    </div>

  {/* Drop your reusable component here */}
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}>
      <Help_Video 
        videoId="igW9f5nbHm4" /* ⚠️ Replace with actual YouTube ID */
        title="How to use Voice to Text" 
      />
    </div>

    <br></br>

      

          <div style={styles.inputGroup}>
            <label style={styles.label}>Interacting Language</label>
            <select value={selectedLang} onChange={(e) => setSelectedLang(e.target.value)} style={styles.select} disabled={loading}>
              <option value="Select Language">Select Language</option>
              <option value="en-US">English (US)</option>
              <option value="hi-IN">Hindi (India)</option>
              <option value="te-IN">Telugu (India)</option>
              <option value="kn-IN">Kannada (India)</option>
              <option value="ta-IN">Tamil (India)</option>
              <option value="ml-IN">Malayalam (India)</option>
              <option value="mr-IN">Marathi (India)</option>
              <option value="gu-IN">Gujarati (India)</option>
              <option value="bn-IN">Bengali (India)</option>
              <option value="pa-IN">Punjabi (India)</option>
              <option value="es-ES">Spanish</option>
              <option value="fr-FR">French</option>
              <option value="de-DE">German</option>
              <option value="it-IT">Italian</option>
              <option value="ja-JP">Japanese</option>
              <option value="zh-CN">Chinese (Mandarin)</option>
              <option value="ru-RU">Russian</option>
            </select>
          </div>

          <div style={styles.inputGroup}>
  <label style={styles.label}>How do you want to enter your lesson?</label>

  <div style={styles.iconChoiceWrapper}>
    <div
      style={{
        ...styles.iconCard,
        borderColor: lessonInputMode === 'image' ? '#4285f4' : '#ccc'
      }}
      onClick={() => setLessonInputMode('image')}
      disabled={loading}
    >
      <div style={styles.icon}>📷</div>
      <div style={styles.iconText}>Upload Image</div>
    </div>

    <div
      style={{
        ...styles.iconCard,
        borderColor: lessonInputMode === 'text' ? '#4285f4' : '#ccc'
      }}
      disabled={loading}
      onClick={() => {
        setLessonInputMode('text');
        setTimeout(() => {
          textAreaRef.current?.focus();
        }, 0);
      }}
      >
      <div style={styles.icon}>⌨️</div>
      <div style={styles.iconText}>Type Lesson</div>
    </div>
  </div>
</div>

{lessonInputMode === 'image' && (
<>
      <div style={styles.inputGroup}>
        <label style={styles.label}>Click or Upload Images</label>
        <input
          type="file"
          disabled={loading}
          accept="image/*"
          multiple
          onChange={handleFilesChange}
          style={styles.input}
        />
      </div>

<div style={{ display: "flex", flexWrap: "wrap", marginTop: 10 }}>
  {previews.map((src, index) => (
    <div key={index} style={{ margin: "10px", position: "relative" }}>
      <img
        src={src}
        alt={`Preview ${index}`}
        style={{ width: 120, height: 120, objectFit: "cover", borderRadius: 8 }}
      />
      <button
        onClick={() => handleRemoveImage(index)}
        style={{
          position: "absolute",
          top: 2,
          right: 2,
          background: "red",
          color: "white",
          border: "none",
          borderRadius: "50%",
          width: 22,
          height: 22,
          cursor: "pointer",
        }}
      >
        ×
      </button>
    </div>
  ))}
</div>
</>
)}

{lessonInputMode === 'image' && files.length > 0 && (
  <button
    onClick={extractTextFromImages}
    disabled={loading}
    style={{
      marginTop: '1rem',
      padding: '0.8rem',
      width: '100%',
      backgroundColor: '#6a1b9a',
      color: '#fff',
      border: 'none',
      borderRadius: '10px',
      fontSize: '1rem',
      fontWeight: '600',
      cursor: 'pointer'
    }}
  >
    {loading ? '🔄 Reading Images...' : '🧠 Read Images'}
  </button>
)}

<br></br>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Lesson Text</label>
            <textarea
              ref={textAreaRef}
              rows="8"
              value={text}
              disabled={loading}
              onChange={(e) => setText(e.target.value)}
              placeholder="Use this for saving poems or full chapters"
              style={styles.textarea}
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Choose what to do with this text:</label>
           <div>
              <label>
                <input
                  type="checkbox"
                  value="associate"
                  disabled={loading}
                  checked={selectedOptions.includes('associate')}
                  onChange={handleCheckboxChange}
                /> Associate with a Lesson 
              </label>
{selectedOptions.includes('associate') && (
  <div>
    <div style={{ marginBottom: '1rem' }}>
      <select
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
        style={styles.select}
      >
        <option value="">Select Subject</option>
        <option value="Biology">Biology</option>
        <option value="Chemistry">Chemistry</option>
        <option value="Computer">Computer</option>
        <option value="English Language">English Language</option>
        <option value="English Literature">English Literature</option>
        <option value="EVS">EVS</option>
        <option value="French">French</option>
        <option value="GK">GK</option>
        <option value="Geography">Geography</option>
        <option value="Hindi Language">Hindi Language</option>
        <option value="Hindi Literature">Hindi Literature</option>
        <option value="History Civics">History Civics</option>
        <option value="Maths">Maths</option>
        <option value="Moral Science">Moral Science</option>
        <option value="Physics">Physics</option>
        <option value="Social Studies">Social Studies</option>
        <option value="Science">Science</option>
        <option value="Other">Other</option>
      </select>
    </div>

    <input
      type="text"
      value={lessonName}
      onChange={(e) => setLessonName(e.target.value)}
      placeholder="Lesson Name"
      style={styles.input}
    />
  </div>
)}

              
              <br />
              <label>
                <input
                  type="checkbox"
                  value="save"
                  disabled={loading}
                  checked={selectedOptions.includes('save')}
                  onChange={handleCheckboxChange}
                /> Save for Future Test/Worksheet Creation
              </label>
              <br />
              <label>
                <input
                  type="checkbox"
                  value="share"
                  disabled={loading}
                  checked={selectedOptions.includes('share')}
                  onChange={handleCheckboxChange}
                /> Share with Parents
                <p style={{ fontSize: '0.9rem', color: '#666', marginTop: '0.5rem' }}>*Please do not share any incomplete or personal use Lessons</p>
              </label>
            </div>
          </div> 

          <div style={styles.buttonGroup}>
            <button onClick={resetText} style={styles.button} disabled={loading}>🧹 Clear</button>
            <button onClick={handleSubmitChoices} style={styles.button_green} disabled={loading}>
              ✅ Submit
            </button>
          </div>

    </div>
  );
};

const styles = {
  iconChoiceWrapper: {
  display: 'flex',
  gap: '1rem',
  justifyContent: 'space-between'
},
iconCard: {
  flex: 1,
  border: '2px solid #ccc',
  borderRadius: '12px',
  padding: '1.2rem',
  textAlign: 'center',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  backgroundColor: '#f9f9f9'
},
icon: {
  fontSize: '2.5rem',
  marginBottom: '0.5rem'
},
iconText: {
  fontSize: '1rem',
  fontWeight: '600'
},

  card: {
    maxWidth: '480px',
    margin: '2rem auto',
    padding: '2rem',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 4px 14px rgba(0,0,0,0.1)',
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif'
  },
  heading: {
    textAlign: 'center',
    fontSize: '1.5rem',
    fontWeight: '700',
    marginBottom: '1.5rem',
    color: '#333'
  },
  error: {
    color: 'red',
    fontWeight: 'bold',
    textAlign: 'center'
  },
  inputGroup: {
    marginBottom: '1.2rem'
  },
  label: {
    fontWeight: '600',
    display: 'block',
    marginBottom: '0.4rem'
  },
  textarea: {
    width: '100%',
    padding: '10px',
    fontSize: '1rem',
    borderRadius: '8px',
    border: '1px solid #ccc',
    resize: 'vertical'
  },
  input: {
    width: '100%',
    padding: '0.6rem 0.9rem',
    border: '1px solid #ccc',
    borderRadius: '8px',
    fontSize: '1rem',
    marginBottom: '0.5rem'
  },
  select: {
    width: '100%',
    padding: '0.6rem 0.9rem',
    border: '1px solid #ccc',
    borderRadius: '8px',
    fontSize: '1rem'
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.8rem',
    marginTop: '1rem'
  },
  button: {
    padding: '0.8rem',
    backgroundColor: '#4285f4',
    color: '#fff',
    fontSize: '1rem',
    border: 'none',
    borderRadius: '10px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 4px 10px rgba(66,133,244,0.4)'
  },
  button_green: {
    padding: '0.8rem',
    backgroundColor: 'green',
    color: '#fff',
    fontSize: '1rem',
    border: 'none',
    borderRadius: '10px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 4px 10px rgba(66,133,244,0.4)'
  }
};

export default VoicetoText;
